module.exports = __webpack_public_path__ + "static/transportation-shop-883c23a7b782abd6101405741738d9fc.jpg";